module.exports = __webpack_public_path__ + "img/hamburguesas.b7d74e22.jpg";